import { SearchFilters } from "@/components/job-search/search-results";
import { allSpecialConditions } from "./visa-data";
export const JOB_MATCHING_KEYWORDS: { [key: string]: string[] } = {
    "nhóm ngành 1": ["Đúc kim loại màu", "Đúc khuôn", "Ép dập kim loại", "Kim loại tấm", "Rèn", "Thi công kết cấu thép", "Gia công cơ khí", "Gia công tinh", "Đúc nhựa", "Hàn", "Sơn", "Lắp ráp thiết bị điện khí", "Kiểm tra máy móc", "Bảo trì máy móc", "Đóng gói công nghiệp"],
    "nhóm ngành 2": ["Đúc kim loại", "Đúc khuôn", "Dập kim loại", "Kim loại tấm", "Rèn", "Chế tạo vật liệu thép", "Gia công cơ khí", "Gia công tinh/ gia công hoàn thiện", "Đúc nhựa", "Hàn", "Sơn", "Điện khí", "Kiểm tra máy", "Bảo dưỡng máy", "Đóng gói công nghiệp", "鋳造", "ダイカスト", "金属プレス", "工場板金", "鍛造", "鉄工", "機械加工", "仕上げ加工", "プラスチック成形", "溶接", "塗装", "電気機器組み立て", "機械検査", "機械保全", "工業包装", "Chūzō", "Daikasuto", "Kinzoku puresu", "Kōjō bankin", "Tanzō", "Tekko", "Kikai kakō", "Shiage kako", "Purasuchikku seikei", "Yōsetsu", "Tosō", "Denki kiki kumitate", "Kikai kensa", "Kikai hozen", "Kōgyō hōsō"],
    "nhóm ngành 3": ["Mạ", "Anod nhôm", "めっき", "アルミニウム陽極酸化処理", "Kikai kakō", "Shiage kako", "Purasuchikku seikei", "Denki kiki kumitate", "Denshi kiki kumitate", "Purinto haisenban", "Kikai kensa", "Kikai hozen", "Kōgyō hōsō"],
    "nhóm ngành xây dựng 1": ["Khoan giếng (Percussion)", "Khoan giếng (Rotary)", "Thi công ván khuôn", "Thi công cốt thép", "Giàn giáo", "Bơm ép bê tông", "Thi công Wellpoint", "Máy xây dựng - San ủi / San nền", "Máy xây dựng - Bốc xếp", "Máy xây dựng - Đào xúc", "Máy xây dựng - Đầm nén", "Gia công kết cấu thép", "Sơn xây dựng", "Sơn cầu thép", "Hàn thủ công", "Hàn bán tự động", "パーカッション式さく井工事作業", "ロータリー式さく井工事作業", "型枠工事作業", "鉄筋組立て作業", "とび作業", "コンクリート圧送工事作業", "ウェルポイント工事作業", "押土・整地作業", "積込み作業", "掘削作業", "締固め作業", "構造物鉄工作業", "建築塗装作業", "鋼橋塗装作業", "手溶接", "半自動溶接", "Paakasshon-shiki saku i kōji sagyō", "Rōtarī-shiki saku i kōji sagyō", "Katawaku kōji sagyō", "Tekkin kumitate sagyō", "Tobi sagyō", "Konkuriito assō kōji sagyō", "Werupointo kōji sagyō", "Osudo / seichi sagyō", "Tsumikomi sagyō", "Kussaku sagyō", "Shimekatame sagyō", "Kōzōbutsu tekkō sagyō", "Kenchiku tosō sagyō", "Kōkyō tosō sagyō", "Te yōsetsu", "Han jidō yōsetsu"],
    "nhóm ngành xây dựng 2": ["Tôn mái, ốp kim loại", "Ống gió, ống dẫn", "Chế tác cửa gỗ", "Mộc xây dựng", "Thi công ván khuôn", "Thi công cốt thép", "Giàn giáo", "Gia công đá", "Ốp lát đá", "Ốp lát gạch", "Lợp ngói", "Trát vữa", "Hoàn thiện nội thất - Sàn nhựa", "Hoàn thiện nội thất - Sàn thảm", "Hoàn thiện nội thất - Khung thép", "Hoàn thiện nội thất - Tấm trần", "Hoàn thiện nội thất - Rèm cửa", "Trang trí tường (giấy dán)", "Thi công cửa nhôm kính", "Chống thấm", "Bơm ép bê tông", "Xây lò công nghiệp", "内外装板金作業", "ダクト板金作業", "木製建具手加工作業", "大工工事作業", "型枠工事作業", "鉄筋組立て作業", "とび作業", "石材加工作業", "石張り作業", "タイル張り作業", "かわらぶき作業", "左官作業", "プラスチック系床仕上げ工事作業", "カーペット系床仕上げ工事作業", "鋼製下地工事作業", "ボード仕上げ工事作業", "カーテン工事作業", "壁装作業", "ビル用サッシ施工作業", "シーリング防水工事作業", "コンクリート圧送工事作業", "築炉作業", "Naigaisō bankin sagyō", "Dakuto bankin sagyō", "Mokusei tategu te kako sagyō", "Daiku kōji sagyō", "Katawaku kōji sagyō", "Tekkin kumitate sagyō", "Tobi sagyō", "Sekizai kakō sagyō", "Ishibari sagyō", "Tairu bari sagyō", "Kawarabuki sagyō", "Sakan sagyō", "Purasuchikku-kei yuka shiage kōji sagyō", "Kāpetto-kei yuka shiage kōji sagyō", "Kōsei shitaji kōji sagyō", "Bōdo shiage kōji sagyō", "Kāten kōji sagyō", "Hekisō sagyō", "Biru-yō sasshi seko sagyō", "Shīringu bōsui kōji sagyō", "Konkuriito assō kōji sagyō", "Chikuro sagyō"],
    "nhóm ngành xây dựng 3": ["Tôn mái, ốp kim loại", "Ống gió, ống dẫn", "Lắp đặt máy lạnh - điều hòa", "Lắp đặt đường ống xây dựng", "Lắp đặt đường ống nhà máy", "Cách nhiệt - bảo ôn", "Hàn thủ công", "Hàn bán tự động", "内外装板金作業", "ダクト板金作業", "冷凍空気調和機器施工作業", "建築配管作業", "プラント配管作業", "保温保冷工事作業", "手溶接", "半自動溶接", "Naigaisō bankin sagyō", "Dakuto bankin sagyō", "Reitō kūki chōwa kiki seko sagyō", "Kenchiku haikan sagyō", "Puranto haikan sagyō", "Ho-on horei kōji sagyō", "Te yōsetsu", "Han jidō yōsetsu"],
    "tấm thép nhà xưởng": ["thép", "xưởng"],
    "dập kim loại": ["dập", "kim loại"],
    "đóng gói công nghiệp": ["đóng gói", "cơ khí"],
    "đóng gói linh kiện": ["đóng gói", "điện tử"],
    "linh kiện ô tô": ["ô tô", "linh kiện"],
    "bếp viện": ["nhà hàng", "dưỡng lão"],
    "hoàn thiện nội thất": ["xây dựng", "nội thất"],
    "tấm thép xây dựng": ["thép", "xây dựng"]
}


export const initialSearchFilters: SearchFilters = {
    q: '',
    visa: '',
    visaDetail: 'all',
    career: '',
    workLocation: [],
    interviewLocation: '',
    job: '',
    experienceRequirement: '',
    gender: '',
    height: [135, 210],
    weight: [35, 120],
    age: [18, 70],
    basicSalary: '',
    realSalary: '',
    hourlySalary: '',
    annualIncome: '',
    annualBonus: '',
    specialConditions: [],
    languageRequirement: '',
    englishRequirement: '',
    educationRequirement: '',
    yearsOfExperience: '',
    tattooRequirement: '',
    netFee: '',
    netFeeNoTicket: '',
    numberRecruits: '',
    interviewRounds: '',
    interviewDate: '',
    interviewDateType: 'until',
    visionRequirement: 'all',
    dominantHand: '',
    otherSkillRequirement: [],
    companyArrivalTime: '',
    workShift: '',
    showExpired: true,
    sortExpiredToEnd: true,
    hasForm: true
};


export const keyMap: { [key: string]: string } = {
    q: 'q',
    visa: 'loai-visa',
    visaDetail: 'chi-tiet-loai-hinh-visa',
    career: 'nganh-nghe',
    workLocation: 'dia-diem',
    interviewLocation: 'dia-diem-phong-van',
    job: 'chi-tiet-cong-viec',
    gender: 'gioi-tinh',
    age: 'do-tuoi',
    height: 'chieu-cao',
    weight: 'can-nang',
    basicSalary: 'luong-co-ban',
    netSalary: 'luong-thuc-linh',
    hourlySalary: 'luong-gio',
    annualIncome: 'thu-nhap-nam',
    annualBonus: 'thuong-nam',
    specialConditions: 'dieu-kien-dac-biet',
    languageRequirement: 'yeu-cau-tieng-nhat',
    englishRequirement: 'yeu-cau-tieng-anh',
    educationRequirement: 'hoc-van',
    experienceRequirement: 'yeu-cau-kinh-nghiem',
    yearsOfExperience: 'so-nam-kinh-nghiem',
    tattooRequirement: 'hinh-xam',
    netFee: 'muc-phi',
    netFeeNoTicket: 'muc-phi-khong-ve',
    quantity: 'so-luong',
    interviewRounds: 'so-vong-phong-van',
    interviewDate: 'ngay-phong-van',
    interviewDateType: 'loai-ngay-phong-van',
    visionRequirement: 'yeu-cau-thi-luc',
    dominantHand: 'tay-thuan',
    otherSkillRequirement: 'yeu-cau-ky-nang-khac',
    companyArrivalTime: 'thoi-diem-ve-cong-ty',
    workShift: 'ca-lam-viec',
    sortBy: 'sap-xep',
    showExpired: 'hien-thi-het-han',
    sortExpiredToEnd: 'het-han-xuong-duoi',
    hasForm: 'co-form-don',
    // hasNiceForm: 'form-don-dep'
};

export const sortOptionMap: { [key: string]: string } = {
    relevancy: 'lien-quan',
    newest: 'moi-nhat',
    salary_desc: 'luong-co-ban-cao-den-thap',
    salary_asc: 'luong-co-ban-thap-den-cao',
    net_salary_desc: 'thuc-linh-cao-den-thap',
    net_salary_asc: 'thuc-linh-thap-den-cao',
    fee_asc: 'phi-thap-den-cao',
    fee_desc: 'phi-cao-den-thap',
    interview_date_asc: 'phong-van-gan-nhat',
    interview_date_desc: 'phong-van-xa-nhat',
    // has_image: 'uu-tien-co-anh',
    // has_video: 'uu-tien-co-video',
    // hot: 'hot-nhat',
    // most_applicants: 'nhieu-nguoi-ung-tuyen',
};

const reverseKeyMap: { [key: string]: string } = Object.fromEntries(
    Object.entries(keyMap).map(([key, value]) => [value, key])
);
const reverseSortOptionMap: { [key: string]: string } = Object.fromEntries(
    Object.entries(sortOptionMap).map(([key, value]) => [value, key])
);

export const generateJobFilter = (readOnlySearchParams: any, _initialSearchFilters: any = initialSearchFilters) => {
    const newFilters: SearchFilters = { ..._initialSearchFilters, workLocation: [], specialConditions: [], otherSkillRequirement: [] };
    let sortOption = 'relevancy';
    let page = 1;
    let entries = null;
    try {
        entries = readOnlySearchParams.entries();
    } catch (error) {
        entries = Object.entries(readOnlySearchParams)
    }
    // console.log(reverseKeyMap)
    for (const [key, value] of entries) {
        const internalKey: string = reverseKeyMap[key] || key;
        if (internalKey === 'sortBy') {
            sortOption = reverseSortOptionMap[value] || 'relevancy';
        } else if (internalKey === 'workLocation' || internalKey === 'otherSkillRequirement') {
            const currentValues = newFilters[internalKey as 'workLocation' | 'otherSkillRequirement'] || [];
            // @ts-ignore
            if (Array.isArray(value)) {
                newFilters[internalKey as 'workLocation' | 'otherSkillRequirement'] = [...currentValues, ...value];
            } else {
                newFilters[internalKey as 'workLocation' | 'otherSkillRequirement'] = [...currentValues, value];
            }
        } else if (internalKey === 'age' || internalKey === 'height' || internalKey === 'weight') {
            const values = readOnlySearchParams.getAll(key);
            if (values.length === 2) {
                // @ts-ignore
                newFilters[internalKey] = [parseInt(values[0], 10), parseInt(values[1], 10)];
            }
        } else if (internalKey === 'specialConditions') {
            const values = Array.isArray(value) ? value : [value];
            const conditionNames = values.map(v => allSpecialConditions.find(c => c.slug === v)?.name).filter(Boolean) as string[];
            newFilters.specialConditions = [...(newFilters.specialConditions || []), ...conditionNames];
        } else if (internalKey === 'page') {
            page = parseInt(value, 10) || 1;
        } else if (internalKey === 'showExpired' || internalKey === 'sortExpiredToEnd' || internalKey === 'hasForm') {
            if (internalKey in newFilters) {
                newFilters[internalKey] = JSON.parse(value?.toLocaleLowerCase() ?? 'true');
            }
        } else {
            if (internalKey in newFilters) {
                // @ts-ignore
                newFilters[internalKey] = value;
            }
        }
    }
    return { sortOption, newFilters, page };
}